module.exports = __webpack_public_path__ + "static/media/selection_discoveryplus.f27cb07d.png";